import type { FilterOption, FilterType } from '@indutrust/shared-model';
import { type } from '@ngrx/signals';
import type { EntityId } from '@ngrx/signals/entities';
import { eventGroup } from '@ngrx/signals/events';

export type FilterSnapshot = {
  id: EntityId;
  mode: FilterType['mode'];
  selectedValues: EntityId[];
};

/**
 * Filter store events for named Redux DevTools actions.
 *
 * @example
 * const dispatch = injectDispatch(filterEvents);
 * dispatch.selectionUpdated({ filterId: 'country', selectedIds: [1] });
 */
export const filterEvents = eventGroup({
  source: 'filter',
  events: {
    filterAdded: type<FilterType>(),
    filterRemoved: type<EntityId>(),
    allFiltersRemoved: type<void>(),
    filterDataUpdated: type<{ filterId: EntityId; data: FilterOption[] }>(),
    filterModeToggled: type<EntityId>(),
    filterModeSet: type<{ filterId: EntityId; mode: 'simple' | 'advanced' }>(),
    selectionUpdated: type<{
      filterId: EntityId;
      selectedIds: FilterType['selectedValues'];
    }>(),
    allSelectionsCleared: type<void>(),
    selectionsRestored: type<FilterSnapshot[]>(),
    allLoadingUpdated: type<boolean>(),
  },
});
